module.exports = __webpack_public_path__ + "02_mole.561a7ec3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer2/02_mole.png
// module id = zZvo
// module chunks = 0